import '../App.css';
import React, { Component, useEffect, useState } from 'react'
import Amplify, {Auth, API, graphqlOperation, Storage } from 'aws-amplify'
import { BrowserRouter as Router, Route, Link} from 'react-router-dom';
import { createSlideshow, deleteSlideshow } from '../graphql/mutations'
import { listSlideshows } from '../graphql/queries'
import { withAuthenticator } from '@aws-amplify/ui-react'
import SlideshowContainer from './SlideshowContainer.js'
import File from './File.js'

import awsExports from "../aws-exports";
Amplify.configure(awsExports);
Storage.configure(awsExports);

class UserPage extends React.Component {
  constructor(){
    super();
    this.state = {
      currentSlideshows: [],
      title:"",
      file: [],
      filePaths: [],
      fileNames: [],
      loaded: false,
      isAuthenticated: false,
      currentFiles: [],
      addedFiles: []
    };
    this.fetchSlideshows();
    
    this.fetchStorage();
  }
  
  async fetchStorage(){
    Storage.list(Auth.user.username + '/') // for listing ALL files without prefix, pass '' instead
    .then(result => this.processStorage(result))
    .catch(err => console.log(err));

  }  
    
  removeSlideshow = async(e)=>{
    console.log(e.target.id);
    try{
        var r = window.confirm("Are you sure you want to DELETE your slideshow?");
        if (r == true) {
            
            
            const slideshow={
                id: e.target.id
            }
            await API.graphql(graphqlOperation(deleteSlideshow, {input: slideshow}));
            alert("Deleted Successfully");
            this.fetchSlideshows();
            
        } 
        
    }catch(err){
        alert("Error Deleting Slideshow: " + err);
    }
  }

  processStorage(results){
    
    const CopyArray = [];//https://slideshowstorage130839-dev.s3.ca-central-1.amazonaws.com/public/
    for(var i = 0; i < results.length; i++){
      CopyArray.push({url: ("https://slideshowstorage130839-dev.s3.ca-central-1.amazonaws.com/public/" + results[i].key), id: results[i].eTag});
    }
    this.setState({currentFiles: CopyArray});
  }

  async fetchSlideshows(){
    try{
      const slideshowData = await API.graphql(graphqlOperation(listSlideshows));
      const slideshows = slideshowData.data.listSlideshows.items;
      const CopyArray = [];

      for(var i = 0; i < slideshows.length; i++){
        if(slideshows[i].owner == Auth.user.username){
          CopyArray.push({title: slideshows[i].name, id: slideshows[i].id, size: slideshows[i].flies.length, slides: slideshows[i].flies});
        }
      }
      this.setState({currentSlideshows: CopyArray});
      
    }catch(err){console.log('error fetching slideshows')}
  }

  
  removeFilesFromStorage= async(e) =>{
    var r = window.confirm("Are you sure you want to DELETE these files from storage?");
    if (r == true) {
        
        this.setState({isUploading: true, LoadingText: "Deleting Files"});
        for(var i = 0; i < this.state.addedFiles.length; i++){
            await Storage.remove(this.state.addedFiles[i].substring(this.state.addedFiles[i].indexOf(Auth.user.username+ "/"), this.state.addedFiles[i].length), {})
            .then (result => console.log("DELETED"))
            .catch(err => console.log(err));
            
        }
        this.setState({openFiles: false, addedFiles: []});
        
        alert("Files Successfully Deleted From Storage");
        this.fetchStorage();
        
    }else{

    }
  }

  addRemoveFileToList = (isAdded, fileUrl, fileId) =>{
      if(isAdded){
          const TempArray = Object.assign([], this.state.addedFiles);
          TempArray.push(fileUrl);
          this.setState({addedFiles: TempArray});

      }
      else{
          const TempArray = Object.assign([], this.state.addedFiles);
          TempArray.splice(this.state.addedFiles.indexOf(fileUrl),1);
          this.setState({addedFiles: TempArray});

      }
  }

  render(){
    return (
      <div className="App">
        <header className="App-header">
          <div id="Username">{Auth.user.username}</div>
          <amplify-sign-out/>
        </header>
        <body>
          <div id="PresentationsHeader">
            <div>Slideshows</div>
          </div>
          <ul id="SlideshowList">
            {
                this.state.currentSlideshows.map((currentSlideshows, index )=>{
                    return(
                        <li id="SlideshowContainerListElement">
                          {React.createElement(SlideshowContainer, {removeSlideshow: this.removeSlideshow, key: currentSlideshows.id, id: currentSlideshows.id, title:currentSlideshows.title, size: currentSlideshows.size, slides: currentSlideshows.slides, new: false})}
                        </li>
                    )
                })
                
            }
            <li id="SlideshowContainerListElement">
              {React.createElement(SlideshowContainer, {key: -1, id: -1, title: "Create New Slideshow", size: 0, slides: [], new: true})}
            </li>
          </ul>

          <div id="PresentationsHeader">
            <div>Files</div>
            <button  onClick={this.removeFilesFromStorage}>Delete ({this.state.addedFiles.length}) File(s) From Storage</button>
          </div>
          
          <ul id="FileList">
            {
                this.state.currentFiles.slice(0,10).map((currentFiles, index )=>{
                    return(
                        <li id="FileListElement">
                          { 
                          React.createElement(File, {addRemove: this.addRemoveFileToList, key: currentFiles.id, id: currentFiles.id, url: currentFiles.url, type: currentFiles.url.substring(currentFiles.url.length-3,currentFiles.url.length)})
                          }
                        </li>
                    )
                })
                
            }
            
            <li style={{display: this.state.currentFiles.length === 0 ? "block" : "none"}}> EMPTY</li>
          </ul>
        </body>
      </div>
    )
  }
}

export default withAuthenticator(UserPage);
/*
class UserPage extends React.Component {
  constructor(){
    super();
    this.state = {
      currentSlideshows: [],
      title:"",
      file: [],
      filePaths: [],
      fileNames: []
    };
    this.fetchSlideshows();
  }

  async fetchSlideshows(){
    try{
      const slideshowData = await API.graphql(graphqlOperation(listSlideshows));
      const slideshows = slideshowData.data.listSlideshows.items;
      const CopyArray = [];

      for(var i = 0; i < slideshows.length; i++){
        if(slideshows[i].owner == Auth.user.username){
          CopyArray.push(slideshows[i].name);
        }
      }
      this.setState({currentSlideshows: CopyArray});
      
    }catch(err){console.log('error fetching slideshows')}
  }
  
  addSlideshow = async(e) =>{
    
    e.preventDefault();
    try{
      const slideshowData = await API.graphql(graphqlOperation(listSlideshows));
      const slideshows = slideshowData.data.listSlideshows.items;

      for(var i = 0; i < slideshows.length; i++){
        console.log(slideshows[i].name + " vs " + this.state.title);
        if(slideshows[i].name == this.state.title && slideshows[i].owner == Auth.user.username){
          alert("A Slideshow with that name already exists");
          return;
        }
      }

      this.uploadImage();
      
      var titleTemp = this.state.title;
      while(titleTemp.search(" ") > 1){
        var index = titleTemp.indexOf(" ");
        
        //console.log(titleTemp.substr(0, index) + "+" + titleTemp.substr(index, titleTemp.length));
        titleTemp = titleTemp.substr(0, index) + "+" + titleTemp.substr(index+1, titleTemp.length);
      }

      const TempArray = Object.assign([], this.state.filePaths);
      for(var i = 0; i < this.state.file.length; i++){
        TempArray.push("https://slideshowstorage130839-dev.s3.ca-central-1.amazonaws.com/public/" + Auth.user.username + "/" + titleTemp + "_" + this.state.file[i].name);
      }
      const slideshow={
        name: this.state.title,
        owner: Auth.user.username,
        flies: TempArray,
        id: 4
      }
      await API.graphql(graphqlOperation(createSlideshow, {input: slideshow}));
      this.setState({
        file: [],
        filePaths: [],
        fileNames: [],
        title: ""
      });
      this.fetchSlideshows();
      alert("Uploaded Successfully");
    }catch(err){
      console.log("error creating slideshow:", err)
    }
  }

  handleChange = e =>{
    
    e.preventDefault();
    switch(e.target.id){
      case "title":
        this.setState({title: e.target.value});
      
        break;
      case "file":
        const CopyArray = e.target.files;
        this.setState({
          file: CopyArray
        });
        console.log(this.state.file);
        break;
    }
    
  }

  uploadImage = e =>{
    for(var i = 0; i < this.state.file.length; i++){
      if(this.state.file[i].name.includes(" ")){
        console.log("ERROR - Make sure image name doesn't have any spaces");
        return;
      }
    }


    const TempArray = Object.assign([], this.state.filePaths);
    for(var i = 0; i < this.state.file.length; i++){
      TempArray.push(this.state.title + "_" + this.state.file[i].name);
    }

    for(var i = 0; i < this.state.file.length; i++){
      Storage.put(Auth.user.username + "/" + TempArray[i], this.state.file[i], {
        level: 'public',
        contentType: 'image/png'
      })
      .then (result => console.log(result))
      .catch(err => console.log(err));
    }

    const CopyArray = Object.assign([], this.state.filePaths);
    const CopyArrayTwo = Object.assign([], this.state.fileNames);

    var titleTemp = this.state.title;
    while(titleTemp.search(" ") > 1){
      var index = titleTemp.indexOf(" ");
      
      //console.log(titleTemp.substr(0, index) + "+" + titleTemp.substr(index, titleTemp.length));
      titleTemp = titleTemp.substr(0, index) + "+" + titleTemp.substr(index+1, titleTemp.length);
    }
    for(var i = 0; i < this.state.file.length; i++){
      CopyArray.push("https://slideshowstorage130839-dev.s3.ca-central-1.amazonaws.com/public/" + Auth.user.username + "/" + titleTemp + "_" + this.state.file[i].name);
      
      CopyArrayTwo.push(this.state.file[i].name);
    }
    this.setState({
      file: [],
      filePaths: CopyArray,
      fileNames: CopyArrayTwo
    });
  }

  StartScreenShare = e => {
    console.log("HELLO");
  }
  
  StopScreenShare = e => {
    console.log("HELLO");
  }

  render(){
    return (
      <div className="App">
        <header className="App-header">
          <div id="Username">John Doe</div>
          <amplify-sign-out/>
        </header>
        <body>
        <div id="PresentationsHeader">Presentations</div>
              <ul id="SlideshowList">
                {
                    this.state.currentSlideshows.map((currentSlideshows, index )=>{
                        return(
                            <li id="SlideshowContainerListElement">
                              {React.createElement(SlideshowContainer, {title:currentSlideshows})}
                            </li>
                        )
                    })
                }
              </ul>
          <h2>Create Slideshow</h2>
          <form onSubmit={this.addSlideshow}>
            <label >Title</label>
            <input id="title" value={this.state.title} onChange={this.handleChange} type="text" required/><br/>
            <input id="file" type="file" accept="image/png" onChange={this.handleChange} multiple/><br/>
            <h3>Slides</h3>
            <h4>
              <ul>
                {
                    this.state.fileNames.map((file, index)=>{
                        return(
                            <li>
                              {file}
                            </li>
                        )
                    })
                }
              </ul>
            </h4>
            <input type="Submit" value="Create"/>
          </form>
          <h1></h1>
        </body>
      </div>
    );
  }
}

          <div><iframe src="https://docs.google.com/viewer?srcid=18hOxQ02K6JOcbvzYamYnoGuTTY63BZH1O7P3kU6QCME&pid=explorer&efh=false&a=v&chrome=false&embedded=true" width="580px" height="480px"></iframe></div>
export default withAuthenticator(UserPage);*/
